import { createSelector } from 'reselect'
import * as gameSelectors from '../game.selectors'

export const getScreens = createSelector(
  [gameSelectors.getScreens, gameSelectors.getStoryLine],
  (screens, storyLine) => {
    return screens
      .filter((screenId) => !!storyLine.screens[screenId])
      .map((screenId) => {
        const storyLineScreen = storyLine.screens[screenId]
        return { ...storyLineScreen }
      })
  }
)
